import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

const notifyToast = (msg) => {
    toast(msg);
}

const successToast = (msg, functionCalled) => {
    const message = msg == '' || msg == ' ' ? 'Success' : msg
    toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        onClose: functionCalled
    });
}

const errorToast = (msg, functionCalled) => {
    const message = msg == '' || msg == ' ' ? 'Error' : msg
    toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        onClose: functionCalled
    });
}

const warnToast = (msg) => {
    toast.warn(msg, {
        position: toast.POSITION.TOP_RIGHT
    });
}

const infoToast = (msg) => {
    toast.info(msg, {
        position: toast.POSITION.TOP_RIGHT
    });
}

const customToast = (msg) => {
    toast(msg, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'foo-bar'
    });
};


export { notifyToast, customToast, infoToast, warnToast, errorToast, successToast }